var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"hometext"},[_c('welcome')],1),_c('OnzeHonden'),_c('Nieuws')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }